import api from './authService';

export const adminService = {
  // Dashboard
  getDashboardStats: () => api.get('/admin/dashboard'),

  // Users
  getAllUsers: (params) => api.get('/admin/users', { params }),
  updateUser: (userId, userData) => api.put(`/admin/users/${userId}`, userData),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),

  // Tasks
  getAllTasks: (params) => api.get('/admin/tasks', { params }),

  // Notifications
  sendSystemNotification: (notificationData) => 
    api.post('/admin/notifications', notificationData),
};